module.exports = __webpack_public_path__ + "img/Icon - One Student.927d4e08.svg";